import React, { useEffect } from "react";
import { Form, InputNumber } from "antd";

function Int({
  form,
  textColor,
  name,
  controlHeight = 40,
  min,
  max,
  defaultValue,
  label,
  width,
  labelCol,
  required,
  errorMessage,
  validateFunction,
  placeholder,
  disabled,
  size,
}) {

  useEffect(() => {
    form.setFieldsValue({ [name]: defaultValue });
  }, [])

  return (
    <Form.Item
      name={name}
      label={label}
      // initialValue={defaultValue}
      labelCol={{ span: labelCol ? labelCol : 8 }}
      style={{ width: width, fontWeight: 600 }}
      rules={[
        {
          required: required,
          message: errorMessage,
        },
        () => ({
          validator(_, value) {
            if (required && !value?.toString()) {
              return Promise.reject(errorMessage);
            };
            if (min?.val?.toString()) {
              if (value < min?.val) {
                return Promise.reject(min?.errorMessage);
              }
            }
            if (max?.val?.toString()) {
              if (value > max?.val) {
                return Promise.reject(max?.errorMessage);
              }
            }

            return Promise.resolve();
          },
        }),
      ]}
    >
      <InputNumber
        disabled={disabled}
        size={size ? size : "large"}
        style={{ width: "100%", backgroundColor: "#fff", fontWeight: 600, height: controlHeight, color: textColor }}
        //  defaultValue={defaultValue}
        placeholder={placeholder}
      />
    </Form.Item>
  );
}

export default Int;
